<template>
    <div class="page-block | u-margin-bottom-narrow">
        <div class="page-block__item-wrapper" v-if="customer">
            <h2 class="page-block__title | u-font-weight-normal">{{ trans('profile.domain.title') }}</h2>
            <div class="page-block__item">
                <div class="page-block__item-content">
                    <div class="layout">
                        <div class="layout__item u-1/4-desk">
                            <span class="page-block__item-content-title"> {{ trans('profile.email') }} </span>
                        </div>
                        <!--
                     -->
                        <div class="layout__item u-3/4-desk">{{ customer.email }}</div>
                    </div>
                    <div class="layout">
                        <div class="layout__item u-1/4-desk">
                            <span class="page-block__item-content-title"> {{ trans('profile.first_name') }} </span>
                        </div>
                        <!--
                     -->
                        <div class="layout__item u-3/4-desk">{{ customer.first_name }}</div>
                    </div>
                    <div class="layout">
                        <div class="layout__item u-1/4-desk">
                            <span class="page-block__item-content-title"> {{ trans('profile.last_name') }} </span>
                        </div>
                        <!--
                     -->
                        <div class="layout__item u-3/4-desk">{{ customer.last_name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
